import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  InputContainer,
  Button,
  ChildrenContainer,
  Anchor
} from './FilesTitlesStyle';

import { DownArrow } from "../../assets/Shared/Icons/DownArrow/DownArrow";
import { UpArrow } from "../../assets/Shared/Icons/UpArrow/UpArrow";
import { useLocation } from "react-router-dom";

// TreeNode component
const TreeNode = React.memo(({ node, onChange, isEditable, fork, activeFileName, setActiveFileName }) => {
  const [expanded, setExpanded] = useState(false);
    const isActive = activeFileName.toLowerCase() === node.title.toLowerCase();
  const anchorRef = useRef(null);

  useEffect(() => {
    if (isActive && anchorRef.current) {
      anchorRef.current.focus();
    }
  }, [isActive]);

  const toggleExpand = () => setExpanded(prev => !prev);

  const handleSelect = (id, title, fileId) => {
    setActiveFileName(title);
    fork(id, title, fileId);
  };

  if (!node?.isFolder) return null;

  return (
    <Container>
      <InputContainer tabIndex={0}>
        <Anchor
          href="#"
          ref={anchorRef}
          aria-current={isActive ? "page" : undefined}
          id={`${node.fileId}`}
          onClick={(e) => {
            e.preventDefault();
            if (node.children?.length > 0) setExpanded(true);
            handleSelect('Id' + node.fileId, node.title, node.fileId);
          }}
          onFocus={() => {
            handleSelect('Id' + node.fileId, node.title, node.fileId);
          }}
        >
          <span className="span" tabIndex={0}>{node.title}</span>
        </Anchor>

        {node.children?.some(child => child.isFolder) && (
          <Button onClick={toggleExpand}>
            {expanded ? (
              <UpArrow color="#333333" size={12} alt="Up Arrow" />
            ) : (
              <DownArrow color="#333333" size={12} alt="Down Arrow" />
            )}
          </Button>
        )}
      </InputContainer>

      {expanded && node.children?.length > 0 && (
        <ChildrenContainer>
          {node.children.map(child => (
            <TreeNode
              key={child.fileId}
              node={child}
              onChange={onChange}
              isEditable={isEditable}
              fork={fork}
              activeFileName={activeFileName}
              setActiveFileName={setActiveFileName}
            />
          ))}
        </ChildrenContainer>
      )}
    </Container>
  );
});

// TreeView component
const TreeView = ({ data, isEditable, fork, activeFileName, setActiveFileName }) => {
  return (
    <>
      {data.map(node => (
        <TreeNode
          key={node.fileId}
          node={node}
          onChange={null}
          isEditable={isEditable}
          fork={fork}
          activeFileName={activeFileName}
          setActiveFileName={setActiveFileName}
        />
      ))}
    </>
  );
};

// FilesTitles component
const FilesTitles = ({ folders, fork, activeFileName: initialFileName = '' }) => {
  const [activeFileName, setActiveFileName] = useState(initialFileName);
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const segments = path.split("/");
    const lastSegment = decodeURIComponent(segments.pop() || segments.pop() || '').trim();

    let formatted = "";

    if (lastSegment === "FAQs" || lastSegment === "" || path === "/support") {
      formatted = "FAQs";
    }
    else if (lastSegment === "Methodology") {
      formatted = "Methodology";
    } else if (lastSegment === "Product_hierarchy") {
      formatted = "Product Hierarchy";
    }

    if (formatted) {
      setActiveFileName(formatted);
    }
  }, [location.pathname]);

  return (
    <TreeView
      data={folders}
      isEditable={false}
      fork={fork}
      activeFileName={activeFileName}
      setActiveFileName={setActiveFileName}
    />
  );
};

export default FilesTitles;